import React, { useState, useRef, useEffect } from "react";
import { utils, write } from "xlsx";
import Papa from "papaparse";

import { DropDownField, TextInputField, CalendarField, MultiSelectField, AutoCompleteField } from "../../../helpers";
import Button from "../../../helpers/Button";
import { Menu } from 'primereact/menu';
import { useDispatch, useSelector } from "react-redux";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { fetchVendorPaymentsPettyCash, updateSearchOptions, updateSearchParams, setSearchConfig } from "../../../services/redux/reducers/vendorPaymentPettyCash/vendorPaymentPettyCash";
import { searchVendorPayments } from "../../../services/api/vendorPayment";
import { getAddFilterOptions, getAutoSearchSuggestions, getDateRange, getFullName, getMatchedRegexPattern, normalizeLabel } from "../../../utils";
import moment from "moment";
import { RadioButton } from "primereact/radiobutton";
import DateFilter from "../../../common/DateFilter";
import { DATE_FORMAT } from "../../../constants";


const vpCreditNonCreditConfig = [
    {
        srNO: 1,
        static: true,
        type: "SELECT",
        name: "dataType",
        label: "Data type",
        options: [
            { label: 'Vendor Payments PettyCash Data', value: 'vendorPaymentsData' }
        ]
    },
    {   srNO: 2,
        static: true,
        type: "SEARCH_TEXT",
        name: "searchText",
        label: "Search Text",
    },
    {
        srNO: 3,
        static: false,
        type: "SELECT",
        name: "purchaseType",
        label: "Purchase Type",
        // options: [
        //     { label: 'REQUEST', value: 'REQUEST' },
        //     { label: 'EXPENSE', value: 'EXPENSE' }
        // ]
    },
    {
        srNO: 5,
        static: false,
        type: "SELECT",
        name: "paymentMode",
        label: "Payment Mode",
        options: [
            { label: 'ONLINE', value: 'ONLINE' },
            { label: 'CASH', value: 'CASH' },
            { label: 'CREDIT', value: 'CREDIT' },
            { label: 'BANK TRANSFER', value: 'BANK TRANSFER' }
        ]
    },
    {
        srNO: 6,
        static: false,
        type: "DATE",
        name: "dateType",
        label: "Date",
        options: [
            { label: 'Created Date', value: 'createdAt' }
        ]
    },
    {
        srNO: 7,
        static: false,
        type: "SELECT",
        name: "statusId",
        label: "Status",
        options: [
            { label: 'PAID', value: 10 },
            { label: 'NOT PAID', value: 9 },
            { label: 'REJECTED', value: 11 },
            { label: 'CANCELLED', value: 6 }
        ]
    },
    {
        srNO: 8,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "vendorPaymentDocNo",
        label:"Vendor Payment No.",
    },
    {
        srNO: 9,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "pettyCashDocNo",
        label:"Petty Cash Doc No.",
    },
    {
        srNO: 10,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "amount",
        label:"Amount",
    },
    {
        srNO: 11,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "userName",
        label:"User Name",
        priority: 1
    },
    {
        srNO: 12,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "docNo",
        label: "Doc No",
    }
]

const Search = (props) => {
    const isLoading = useSelector(state => state.vendorPaymentsPettyCash.loading)

    const [suggestions, setSuggestions] = useState([])

    const usersData = useSelector(state => state.userDetails)
    const searchParams = useSelector(state => state.vendorPaymentsPettyCash.searchParams)
    const paginationParams = useSelector(state => state.vendorPaymentsPettyCash.paginationParams)
    const searchOptions = useSelector(state => state.vendorPaymentsPettyCash.searchOptions)
    const companyBranches = usersData?.PMCompanyDetails?.companyBranches
    const statusList = useSelector((state) => state.common.status)

    const filterMenu = useRef(null)
    const downloadMenu = useRef(null)
    const searchTextRef = useRef(null)

    const searchConfig = vpCreditNonCreditConfig

    const dispatch = useDispatch()

    useEffect(()=>{
        dispatch(setSearchConfig(vpCreditNonCreditConfig))
        if(searchOptions.length === 0){
            const filteredSearchOptions = searchConfig.filter(eachOption => eachOption.static)
            dispatch(updateSearchOptions(filteredSearchOptions))
        }
    }, [])
    
    const addFilterOption = (srNO) => {
        const relatedConfig = searchConfig.find(eachConfig => eachConfig.srNO === srNO)
        if(relatedConfig.name === "branchId"){
            const updatedCompanyBranches = companyBranches?.map(eachCompanyBranch => ({...eachCompanyBranch, label:eachCompanyBranch.branchName, value:eachCompanyBranch.branchId}))
            relatedConfig.options = updatedCompanyBranches
        }
        dispatch(updateSearchOptions([...searchOptions, relatedConfig]))
    }

    const removeFilterOption = (srNO) => {
        const relatedSearchOption = searchOptions.find(eachOption => eachOption.srNO === srNO)
        const updatedSearchParams = {...searchParams}

        if(relatedSearchOption.type === "SEARCH_BY"){
            updatedSearchParams.searchText = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if(relatedSearchOption.type === "DATE"){
            updatedSearchParams.fromDate = null
            updatedSearchParams.toDate = null
            updatedSearchParams.range = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if(relatedSearchOption.type === "SELECT"){
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if (relatedSearchOption.type === "TEXT") {
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if (relatedSearchOption.type === "MULTISELECT") {
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }

        const filteredSearchOptions = searchOptions.filter(eachOption => eachOption.srNO !== srNO)
        dispatch(updateSearchOptions([...filteredSearchOptions]))
    }

    const handleSearchOnChange = (event) => {
        let eventValue = event.target.value

        if(eventValue && (eventValue.userId || eventValue.companyId)){
            eventValue = eventValue.displayName
        }

        const updatedSearchParams = {...searchParams, [event.target.name]: eventValue}

        if (eventValue instanceof Date) {
            if(new Date(searchParams[event.target.name])?.getTime() != eventValue.getTime()){
                updatedSearchParams.range = null
            }

            if (event.target.name === "toDate") {
                eventValue.setHours(23, 59, 0, 0)
            }
            if (event.target.name === "fromDate") {
                eventValue.setHours(0, 0, 0, 0)
            }
            eventValue = eventValue.toISOString()

            updatedSearchParams[event.target.name] = eventValue
        }

        if(event.target.name === "searchText"){
            const availableOptions = [...vpCreditNonCreditConfig]
            const matchText = eventValue.split(";")[0]
            const matchedPattern = getMatchedRegexPattern(matchText, availableOptions, searchParams.searchBy)
            updatedSearchParams.searchBy = matchedPattern
        }
        
        dispatch(updateSearchParams(updatedSearchParams))
    }

    const handleDateRangeChange = (range) => {
        const { fromDate, toDate } = getDateRange(range)
        getDateRange(range)
        dispatch(updateSearchParams({ ...searchParams, range, fromDate, toDate }))
    }

    const addFilterOptions = getAddFilterOptions(searchConfig, searchOptions, searchParams, addFilterOption)

    const handleSearchKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch()
        }
    } 

    const handleSearch = () => {
        let errorFound = false

        if (searchParams.searchText === "" && searchParams.searchBy !== "all") {
            dispatch(raiseToast({ severity: 'error', summary: normalizeLabel(searchParams.searchBy), detail: "Please enter search text" }))
            errorFound = true
        } 
        else if (searchParams.searchText && searchParams.searchBy !== "all"){
            const relatedSearchOption = searchConfig.find(eachOption => eachOption.name === searchParams.searchBy)
            if(relatedSearchOption.isValid && !relatedSearchOption.isValid(searchParams.searchText.split(";")[0])){
                dispatch(raiseToast({ severity: 'error', summary: normalizeLabel(searchParams.searchBy), detail: `Please enter valid ${normalizeLabel(searchParams.searchBy).toLowerCase()}` }))
                errorFound = true
            }
        }
        
        searchOptions.map(eachOption => { 
            if (["TEXT", "SELECT", "AUTO_COMPLETE"].includes(eachOption.type)) {
                if (!searchParams[eachOption.name] && searchParams[eachOption.name] !== false) {
                    const errorMsgText = normalizeLabel(eachOption.label)
    
                    dispatch(raiseToast({ severity: 'error', summary: errorMsgText, detail: `Please enter ${errorMsgText.toLowerCase()}` }))
                    errorFound = true
                } else {
                    if(eachOption.isValid && !eachOption.isValid(searchParams[eachOption.name].split(";")[0])){
                        const errorMsgText = normalizeLabel(eachOption.label)
                        dispatch(raiseToast({ severity: 'error', summary: errorMsgText, detail: `Please enter valid ${errorMsgText.toLowerCase()}` }))
                        errorFound = true
                    }
                }
            } 
        })

        const updatedSearchParams = {...searchParams}

        if(updatedSearchParams.searchBy !== "all"){
            updatedSearchParams[updatedSearchParams.searchBy] = updatedSearchParams.searchText.trim()
        }

        const vendorPaymentParams = {
            ...paginationParams,
            ...updatedSearchParams,
            pageNo: 0,
            isPettyCashReq: true,
            paginator: true
        }

        if(!searchParams.statusId){
            vendorPaymentParams.statusIds = [6, 9, 10, 11]
        } else {
            vendorPaymentParams.statusIds = [searchParams.statusId]
        }

        if(!errorFound){
            dispatch(fetchVendorPaymentsPettyCash(vendorPaymentParams))
        }
    }

    const downloadFormatOptions = [
        {
            label: "XLSX",
            command: () => downloadData("XLSX")
        },
        {
            label: "CSV",
            command: () => downloadData("CSV")
        }
    ]

    const downloadData = async (dataFormat) => {
        const downloadParams = {
            ...searchParams, 
            ...paginationParams, 
            isPettyCashReq: true, 
            paginator: false, 
            limitedPagination: false
        }

        if(downloadParams.searchBy !== "all"){
            downloadParams[downloadParams.searchBy] = downloadParams.searchText.trim()
        }
        
        const response = await searchVendorPayments(downloadParams)

        if (response.failure){
            return dispatch(raiseToast({ severity: 'error', detail: response.data.error, life: 3000 }))
        }

        const vendorPaymentData = response.data.data
        const bookingLogs = response.data.bookingLogs

        let pettyCashes = []

        for (let i = 0; i < vendorPaymentData.length; i++) {
            let counter = i + 1

            const vendorPayment = vendorPaymentData[i]

            let kamName = getFullName(vendorPayment["users.firstName"], vendorPayment["users.lastName"])
            let relatedStatus = statusList?.find(eachStatus => eachStatus.statusId === vendorPayment?.statusId)
            let bookedDate = ""

            let relatedBookingLog = bookingLogs.find(eachBookingLog => eachBookingLog.docNo === vendorPayment["pettyCash.docNo"])
            if(relatedBookingLog?.bookedAt){
                bookedDate = moment(relatedBookingLog.bookedAt).format(DATE_FORMAT)
            }

            const downloadObj = {
                'Sr. No.': counter,
                'Petty Cash No.': vendorPayment["pettyCash.docNo"],
                'Vendor Payment No.': vendorPayment["docNo"],
                'Amount': vendorPayment.amount,
                'KAM': kamName,
                'VP Status': relatedStatus?.status,
                'Booked Status': relatedBookingLog?.bookedStatus ? "Yes" : "No",
                'Booked Date': bookedDate
            }

            pettyCashes.push(downloadObj)
        }

        if(dataFormat === "CSV"){
            let csv = Papa.unparse(pettyCashes, { download: true })
            let blob = new Blob([csv])
            let a = window.document.createElement("a")
            a.href = window.URL.createObjectURL(blob, { type: "text/plain" })
            a.download = "pettyCash.csv"
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        }
        if(dataFormat === "XLSX"){
            const ws = utils.json_to_sheet(pettyCashes)
            const wb = utils.book_new()
            utils.book_append_sheet(wb, ws, 'Sheet1')
            const blob = new Blob([write(wb, { bookType: 'xlsx', type: 'array' })])
            const url = URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = 'pettyCash.xlsx'
            a.click()
            URL.revokeObjectURL(url)
        }
    }

    return (
        <div className="p-card" style={{border:"1px solid #e9ecef"}} onKeyDown={handleSearchKeyPress}>
            <div className="grid"> 
                {
                    searchOptions.map(eachOption => {
                        if (eachOption.type === "SEARCH_TEXT") {

                            let searchByOptions = [{label: 'No Filters', value: 'all'}]
                            searchConfig.map(eachSearchBy => {
                                if (eachSearchBy.isSearchByOption) {
                                    const optionInUse = searchOptions.find(eachSearchOption => eachSearchOption.srNO === eachSearchBy.srNO)
                                    if(!optionInUse){
                                        searchByOptions.push({ label: eachSearchBy.label, value: eachSearchBy.name })
                                    }
                                }
                            })
    
                            return (
                                <>
                                    <div className="flex flex-column col-12">
                                        <TextInputField
                                            name="searchText"
                                            labelText="Search Text"
                                            placeholder="No Filter"
                                            refName={searchTextRef}
                                            value={searchParams["searchText"]}
                                            onChange={handleSearchOnChange}
                                        />
                                    </div>
                                    {searchParams.searchText && (
                                        <div className="flex flex-column col-12">
                                            <DropDownField
                                                name="searchBy"
                                                labelText="Search By"
                                                options={searchByOptions}
                                                value={searchParams["searchBy"]}
                                                onChange={handleSearchOnChange}
                                            />
                                        </div>
                                    )}
                                </>
                            )
                        }

                        if(eachOption.type === "DATE"){
                            return (
                                <>  
                                    <DateFilter 
                                        eachOption={eachOption} 
                                        searchParams={searchParams} 
                                        dateOptions={["MTD", "PM", "L15", "L30"]}
                                        handleDateRangeChange={handleDateRangeChange} 
                                        handleSearchOnChange={handleSearchOnChange}
                                        removeFilterOption={removeFilterOption}
                                    />
                                </>
                            )
                        }
                        if(eachOption.type === "SELECT"){
                            return (
                                <>
                                    { !eachOption.static ? 
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={()=> removeFilterOption(eachOption.srNO)} ></i>
                                        </div>
                                        :
                                        null 
                                    }
                                   {
                                        eachOption.name === "paymentMode" ? 
                                            (
                                                <div className="flex flex-column col-12">
                                                    <MultiSelectField name={eachOption.name} options={eachOption.options} labelText={eachOption.label} value={searchParams[eachOption.name]} onChange={handleSearchOnChange} />
                                                </div>
                                            ) :
                                            ( 
                                                <div className="flex flex-column col-12">
                                                    <DropDownField name={eachOption.name} options={eachOption.options} labelText={eachOption.label} value={searchParams[eachOption.name]} onChange={handleSearchOnChange} />
                                                </div>
                                            )
                                    }
                                </>
                            )
                        }

                        if (eachOption.type === "TEXT") {
                            return (
                                <>
                                    {!eachOption.static &&
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={() => removeFilterOption(eachOption.srNO)} ></i>
                                        </div>
                                    }
                                    {
                                        <div className="flex flex-column col-12">
                                            <TextInputField name={eachOption.name} labelText={eachOption.label} value={searchParams[eachOption.name]} onChange={handleSearchOnChange} />
                                        </div>
                                    }
                                </>
                            )
                        }
                    })
                }
                <div className="flex col-12 justify-content-end">
                    <Menu model={addFilterOptions} popup ref={filterMenu} />
                    <Button icon="pi pi-filter" className="h-2rem p-2 action-btn hover:surface-300 hover:text-700" label="Add Filter" onClick={(e) => filterMenu.current.toggle(e)} />
                </div>

                <div className="flex flex-column col-12 mb-0 pb-0">
                    <div className="grid">
                        <div className="flex col-12 mb-0 gap-1 pb-0" style={{cursor: isLoading? 'not-allowed' : 'pointer'}}>
                            <Button label="Search" style={{flexGrow: 1}} className="py-2" onClick={handleSearch} disabled={isLoading}/>
                            <Menu model={downloadFormatOptions} popup ref={downloadMenu} />
                            <Button icon="pi pi-download" className="py-2 px-3"  onClick={(e) => downloadMenu.current.toggle(e)} permissions={[247]}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Search;
